import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useWtrSelector } from 'redux/hooks';
import { getProductReviews } from 'redux/modules/product-details/selectors/product-properties';

import { getPDPUrl } from 'utils/product';
import servingInstructions from 'constants/servingInstructions';

import ProductAttributes from 'components/Product/Attributes';

import StarRating from 'components/StarRating';
import Typography from '@johnlewispartnership/wtr-ingredients/foundations/typography';

import ProductPodPromotions from 'components/ProductPod/Promotions';

import styles from './index.scss';

const productPodAttributesDefaultPropReportAnalyticsClick = () => null;

const ProductPodAttributes = ({
  attributes = null,
  cookingStatus,
  entertaining = false,
  productName,
  productId,
  qualifier,
  currentSaleUnitPrice,
  reportAnalyticsClick = productPodAttributesDefaultPropReportAnalyticsClick,
}) => {
  const hasReviews = useWtrSelector(
    state => (getProductReviews(state, productId)?.reviewCount || 0) > 0,
  );

  const servingInstructionsAttributes = servingInstructions[cookingStatus];
  const showEntertainingAttributes = entertaining && !!attributes && Object.keys(attributes).length;
  const showServingInstructions = entertaining && servingInstructionsAttributes;

  return productId ? (
    <>
      {hasReviews ? (
        <div className={styles.ratingWrapper}>
          <StarRating
            lighter
            isSizeSmall
            hasSchema={false}
            linkTo={getPDPUrl(productId, productName)}
            productId={productId}
            clickHandler={reportAnalyticsClick}
            productName={productName}
          />
        </div>
      ) : (
        <div className={styles.ratingWrapper}>
          <Typography styleAs="paragraph" textStyle="body-m">
            {' '}
            No reviews yet
          </Typography>
        </div>
      )}
      <ProductPodPromotions productId={productId} currentSaleUnitPrice={currentSaleUnitPrice} />
      {showEntertainingAttributes && (
        <div className={styles.podEntertainingAttributes}>
          <div className={styles.entertainingDetails}>
            <ProductAttributes
              shortLeadTime
              attributes={attributes}
              identifier={`entertainingAttributes${qualifier ? `-${qualifier}` : ''}`}
            />
          </div>
        </div>
      )}
      {showServingInstructions && (
        <div className={styles.servingInstructions}>
          <ProductAttributes attributes={{ [servingInstructionsAttributes]: true }} />
        </div>
      )}
    </>
  ) : null;
};

ProductPodAttributes.displayName = 'ProductPodAttributes';

ProductPodAttributes.propTypes = {
  attributes: PropTypes.shape({
    [PropTypes.string]: PropTypes.string,
  }),
  cookingStatus: PropTypes.oneOf(Object.keys(servingInstructions)),
  entertaining: PropTypes.bool,
  productName: PropTypes.string,
  productId: PropTypes.string,
  qualifier: PropTypes.string,
  reportAnalyticsClick: PropTypes.func,
};

export default memo(ProductPodAttributes);
